import type {
  PapiDeviation,
  PapiDiscordOwnerConnectionInfo,
} from '@wix/da-papi-types';
import { createAction } from 'redux-actions';
import { reduxKey } from './constants';

/**
 * To be fired when the dynamically loaded discord redux module finishes loading
 */
export const reduxInitialized = createAction(
  `${reduxKey}/REDUX_INITIALIZED`,
  () => ({})
);

export const fetchConnectionInfo = createAction(
  `${reduxKey}/AUTHOR/GET_CONNECTION`,
  () => ({})
);
export const updateConnectionInfo = createAction(
  `${reduxKey}/AUTHOR/UPDATE_CONNECTION`,
  (connectionInfo: PapiDiscordOwnerConnectionInfo) => connectionInfo
);
export const fetchRoles = createAction(
  `${reduxKey}/AUTHOR/GET_ROLES`,
  () => ({})
);
export const updateRoles = createAction(
  `${reduxKey}/AUTHOR/UPDATE_ROLES`,
  (
    roles: {
      name: string;
      id: string;
    }[]
  ) => ({ roles })
);
export const connect = createAction(
  `${reduxKey}/AUTHOR/CONNECT`,
  (oauth2Link: string) => ({ oauth2Link })
);
export const connectionSuccess = createAction(
  `${reduxKey}/AUTHOR/CONNECT_SUCCESS`,
  (justNow: boolean) => ({ justNow })
);
export const connectionFail = createAction(
  `${reduxKey}/AUTHOR/CONNECT_FAIl`,
  () => ({})
);
export const disconnect = createAction(
  `${reduxKey}/AUTHOR/DISCONNECT`,
  () => ({})
);
export const disconnectSuccess = createAction(
  `${reduxKey}/AUTHOR/DISCONNECT_SUCCESS`,
  () => ({})
);
export const disconnectFail = createAction(
  `${reduxKey}/AUTHOR/DISCONNECT_FAIL`,
  () => ({})
);
export const subscriberConnect = createAction(
  `${reduxKey}/SUBSCRIBER/CONNECT`,
  (tier: PapiDeviation) => ({ oauth2Url: tier.tier?.discord?.oauth2 })
);
export const subscriberConnectSuccess = createAction(
  `${reduxKey}/SUBSCRIBER/CONNECT_SUCCESS`,
  (guildId: string | undefined) => ({ guildId })
);
export const subscriberConnectFail = createAction(
  `${reduxKey}/SUBSCRIBER/CONNECT_FAIL`,
  () => ({})
);
